// extracted by mini-css-extract-plugin
export default {"userContainer":"userInfoContainer_userContainer__OLZ5k","user-info":"userInfoContainer_user-info__lbJq1"};